import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const BreadcrumbsADPLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <SkeletonBlock
      className={className}
      style={style}
      $width="100%"
      $height="20px"
    />
  );
};
